import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../../incidentes.css";

const proceso = {
  titulo: "Solicitud de Material de Marketing",
  descripcion:
    "Descripción: Proceso para solicitar el diseño y/o revisión de material publicitario y de marketing del área de Administración y Finanzas.",
};

const Marketing = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Marketing</h1>
        </div>
        <div className="orgproc-grid">
          <div className="orgproc-card">
            <div className="orgproc-card-accent"></div>
            <div className="orgproc-card-body">
              <div className="orgproc-eyebrow">Proceso #1</div>
              <div className="orgproc-card-title">{proceso.titulo}</div>
              <p className="orgproc-card-desc">{proceso.descripcion}</p>
              <div className="orgproc-card-actions">
                <Link className="orgproc-card-btn" to="/marketing/imagen-proceso">
                  Ver imagen del proceso →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Marketing;
